import React from 'react';
import { LangContext } from '../../contexts/lang.context';
import { Box } from '@material-ui/core';
import { ContactForm } from './ContactForm';
import { ContactList } from './ContactList';
import { SectionTitle, HintText } from '../ui';

export const ContactSection: React.FC = () => {
  const { CONTACT_SECTION } = React.useContext(LangContext).currentLangData;

  return (
    <>
      <HintText text={CONTACT_SECTION.hint} />
      <SectionTitle title={CONTACT_SECTION.title} />
      <ContactForm />
      <Box pb={2} />
      <ContactList />
    </>
  );
};

export default ContactSection;
